const revenueAttributionMethods = {
  hours: { id: 'hours', name: 'Percentage of Billable Hours' },
  tm_basis: { id: 'tm_basis', name: 'Percentage of Time & Materials Revenue' },
};

export default revenueAttributionMethods;
